export const updateNotificationState = (data: any) => ({
  type: "UPDATE_NOTIFICATION_STATE",
  payload: data,
});
